export default __webpack_public_path__ + "static/media/SourceSansPro-Bold.d0487a18.ttf";